export const TIME_FILTER_TEXT = {
	inputLabel: 'Departure time',
};

export const DEFAULT_TIME = '00:00';
